import React from 'react';

import Typography from '@pb/kit-component-typography';

type HowItWorksProps = {
    description: string,
};

export const HowItWorks: React.FC<HowItWorksProps> = ({description}) => {
    return (
        <Typography variant="body-level-1">{description}</Typography>
    );
};
